module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/94b02bb03ed16e390321b636a65ec742.png";